import React from 'react';
import IC_customer from '../components/IC/IC_customer';
import IC_customer_order from '../components/IC/IC_customer_order';
import IC_customer_order_rows from '../components/IC/IC_customer_order_rows';
import IC_customer_offer from '../components/IC/IC_customer_offer';
import IC_customer_offer_rows from '../components/IC/IC_customer_offer_rows';
import IC_customer_contacts from '../components/IC/IC_customer_contacts';
import IC_customer_offices from '../components/IC/IC_customer_offices';
import IC_customer_ddt_rows from '../components/IC/IC_customer_ddt_rows';
import IC_supplier from '../components/IC/IC_supplier';
import IC_supplier_order from '../components/IC/IC_supplier_order';
import IC_supplier_order_rows from '../components/IC/IC_supplier_order_rows';
import IC_supplier_transport_document_rows from '../components/IC/IC_supplier_transport_document_rows';
import IC_shipping_plan from '../components/IC/IC_shipping_plan';
import IC_manufacturing_process_model from '../components/IC/IC_manufacturing_process_model';
import IC_mp_children from '../components/IC/IC_mp_children';
import IC_item_model from '../components/IC/IC_item_model';
import IC_item_model_suppliers from '../components/IC/IC_item_model_suppliers';


export default function InstanceCompilerTopHook({ data, dataId, entity = null, setDataKeyValue }) {

    if (entity === null) {
        return <></>;
    }

    const props = { data, dataId, entity, setDataKeyValue };

    switch (entity) {
        case 'customer':
            return <IC_customer {...props} />;
        case 'customer_order':
            return <IC_customer_order {...props} />;
        case 'customer_order_rows':
            return <IC_customer_order_rows {...props} />;
        case 'customer_offer':
            return <IC_customer_offer {...props} />;
        case 'customer_offer_rows':
            return <IC_customer_offer_rows {...props} />;
        case 'customer_contacts':
            return <IC_customer_contacts {...props} />;
        case 'customer_offices':
            return <IC_customer_offices {...props} />;
        case 'customer_ddt_rows':
            return <IC_customer_ddt_rows {...props} />;
        case 'supplier':
            return <IC_supplier {...props} />;
        case 'supplier_order':
            return <IC_supplier_order {...props} />;
        case 'supplier_order_rows':
            return <IC_supplier_order_rows {...props} />;
        case 'supplier_transport_document_rows':
            return <IC_supplier_transport_document_rows {...props} />;
        case 'shipping_plan':
            return <IC_shipping_plan {...props} />;
        case 'manufacturing_process_model':
            return <IC_manufacturing_process_model {...props} />;
        case 'mp_children':
            return <IC_mp_children {...props} />;
        case 'item_model':
            return <IC_item_model {...props} />;
        case 'item_model_suppliers':
            return <IC_item_model_suppliers {...props} />;
        default:
            return <></>;
    }
};
